/*
 * Copyright (c) 2025 - 2026. Bluemate B.V.
 */
import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {NotificationProps, NotificationTypeProps} from '../notificationsPage';

import useDefaultNotification from '../useDefaultNotification';

import NotificationProducts from '../notificationComponents/notificationProducts';

import NotificationActions from '../notificationComponents/notificationActions';

import NotificationChannelsSelect from '../notificationComponents/notificationChannelsSelect';

import NotificationChannelsBadge from '../notificationComponents/notificationChannelsBadge';

import Notification from '../../../models/notificationModel';

import {NotificationType} from '../../../util/enums';

import {AwesomeIcon} from '@dvrd/dvr-controls';

import classNames from 'classnames';

import BluemateBadgePremium from '../bluemateBadgePremium';

function ProductHijackNotification(props: NotificationProps) {
    const {t} = useTranslation();
    const {
        notification,
        loading,
        onDeleteNotification,
        onSendTestNotification,
        disabled,
        canDelete,
        canEdit,
        onReplaceNotification
    } = props;
    const [onChangeEmailAddresses] = useDefaultNotification(props);

    return (
        <div className={classNames('product-hijack-notification notification-config', disabled && 'disabled')}>
            <label className='notification-title'>
                <AwesomeIcon name='user-shield' className='type-icon' />{' '}
                {t('notifications.productHijack.title', 'Productkaping notificatie')}{' '}
                <NotificationChannelsBadge notification={notification} /> <BluemateBadgePremium />
            </label>
            <div className='notification-card'>
                <div className='notification'>
                    <NotificationProducts
                        onSuccess={onReplaceNotification}
                        notification={notification}
                        disabled={loading || disabled || !canEdit}
                        text={t('notifications.productHijack.productsText', 'Bij een nieuwe verkoper op')}
                    />
                    <NotificationChannelsSelect
                        notification={notification}
                        disabled={loading || disabled || !canEdit}
                        onChangeEmailAddresses={onChangeEmailAddresses}
                        onReplaceNotification={onReplaceNotification}
                    />
                </div>
                <NotificationActions
                    onDeleteNotification={onDeleteNotification}
                    onSendTestNotification={onSendTestNotification}
                    disabled={disabled}
                    notification={notification}
                    canDelete={canDelete}
                />
            </div>
        </div>
    );
}

export default function ProductHijackNotifications(props: NotificationTypeProps) {
    const {notifications, moduleActive} = props;
    const hijackNotifications = useMemo(() => {
        return notifications.filter(
            (notification: Notification) => notification.notificationType === NotificationType.PRODUCT_HIJACK
        );
    }, [notifications]);
    if (!hijackNotifications.length) return null;

    function renderNotification(notification: Notification) {
        return (
            <ProductHijackNotification
                key={notification.id}
                notification={notification}
                disabled={!moduleActive}
                {...props}
            />
        );
    }

    return (
        <div className='notification-type product-hijack-notifications'>
            <div className='notifications'>{hijackNotifications.map(renderNotification)}</div>
        </div>
    );
}
